import React from 'react';
import { IModalDescription, IModalProps } from '@cp/shared/modal';
import { ModalContainer, ModalLayout } from '@cp/ds/src/components/modalLayout';
import { ClientProfileViewModel } from '@common/model/client';
import { ClientPersonalInformationForm, ClientPersonalInformationFormProps } from './clientPersonalInformationForm';

export interface ClientPersonalInformationModalProps extends IModalProps {
  clientProfile: ClientProfileViewModel;
  sendSupportMessage: ClientPersonalInformationFormProps['sendSupportMessage'];
}

export const ClientPersonalInformationModal: React.FC<ClientPersonalInformationModalProps> = ({
  onCancel,
  onSuccess,
  clientProfile,
  sendSupportMessage,
}) => {
  return (
    <ModalLayout containerSx={{ position: 'relative', width: { xs: 1, md: 720 } }} onBack={onCancel} title="Персональные данные">
      <ModalContainer>
        <ClientPersonalInformationForm clientProfile={clientProfile} onComplete={onSuccess} sendSupportMessage={sendSupportMessage} />
      </ModalContainer>
    </ModalLayout>
  );
};

/**
 * CLIENT_PERSONAL_INFORMATION_MODAL is a constant object representing the
 * modal configuration for displaying client personal information. It includes
 * a namespace (nss) for uniquely identifying the modal and a loader function
 * to dynamically load the modal component when required.
 */
export const CLIENT_PERSONAL_INFORMATION_MODAL: IModalDescription<ClientPersonalInformationModalProps> = {
  nss: 'client/personal-information',
  loader: () => Promise.resolve(ClientPersonalInformationModal),
};
